import React from "react";
import { GitBranch, Star } from "lucide-react";
import "./index.css";

interface VersionManagementProps {
  versions: any;
  selectedDate: string;
  currentVersionId: string | null;
  loadVersion: (versionId: string) => void;
  hasUnsavedChanges: boolean;
  onSetActivePlan: (planId: string, isCurrentlyActive: boolean) => void;
  isUpdatingActivePlan: boolean;
}

const VersionManagement: React.FC<VersionManagementProps> = ({
  versions,
  selectedDate,
  currentVersionId,
  loadVersion,
  hasUnsavedChanges,
  onSetActivePlan,
  isUpdatingActivePlan,
}) => {
  const getCurrentVersions = () => {
    return Object.values(versions[selectedDate] || {})
      .filter((version: any) => !version.isInitialPlan)
      .sort(
        (a: any, b: any) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      );
  };

  return (
    <div className="version-management-container">
      <div className="version-list-container">
        {getCurrentVersions().map((version: any) => (
          <div
            key={version.id}
            className={`version-list-item ${
              currentVersionId === version.id
                ? "version-list-item--active"
                : "version-list-item--inactive"
            }`}
            onClick={() => loadVersion(version.id)}
          >
            <div className="version-item-content-wrapper">
              <GitBranch className="version-item-branch-icon" />
              <span className="version-item-name-text">{version.name}</span>
              {version.isActive && !version.isInitialPlan && (
                <Star className="version-item-active-indicator" />
              )}
            </div>
            <div className="version-item-actions-container">
              {!version.isActive && !version.isInitialPlan && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onSetActivePlan(version.id, version.isActive);
                  }}
                  disabled={isUpdatingActivePlan}
                  className="version-set-active-button"
                  title="Set as active plan"
                >
                  <Star className="version-set-active-icon" />
                </button>
              )}
              <div className="version-date-container">
                {!version.isInitialPlan && (
                  <span className="version-date-text">
                    {new Date(version.createdAt).toLocaleDateString()}
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VersionManagement;